export default __webpack_public_path__ + "static/media/shape-circle-left.27aced60.png";